import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CalendarTime } from "../../assets/icons/calendar-time.svg";
import { ReactComponent as ChatError } from "../../assets/icons/chat-error.svg";
import { ReactComponent as Dashboard } from "../../assets/icons/dashboard.svg";
import { ReactComponent as DollarSign } from "../../assets/icons/dollar-sign.svg";
import { ReactComponent as IntegrationTable } from "../../assets/icons/integration-table.svg";
import { ReactComponent as Integration } from "../../assets/icons/integration.svg";
import { ReactComponent as Management } from "../../assets/icons/management.svg";
import { ReactComponent as MapPin } from "../../assets/icons/map-pin.svg";
import { ReactComponent as Map } from "../../assets/icons/map.svg";
import { ReactComponent as Marker } from "../../assets/icons/marker.svg";
import { ReactComponent as MyRequest } from "../../assets/icons/my-request.svg";
import { ReactComponent as Note } from "../../assets/icons/note.svg";
import { ReactComponent as OwnDelivery } from "../../assets/icons/own-delivery.svg";
import { ReactComponent as Package } from "../../assets/icons/package.svg";
import { ReactComponent as PersonInfo } from "../../assets/icons/person-info.svg";
import { ReactComponent as PigMoney } from "../../assets/icons/pig-money.svg";
import { ReactComponent as Reverse } from "../../assets/icons/reverse.svg";
import { ReactComponent as Send } from "../../assets/icons/send.svg";
import { ReactComponent as ShoppingCart } from "../../assets/icons/shopping-cart.svg";
import { ReactComponent as SlideSearch } from "../../assets/icons/slide-search.svg";
import { ReactComponent as User } from "../../assets/icons/user.svg";

import { FaFileExcel, FaHandHolding, FaRegFileExcel } from "react-icons/fa";
import { BiSolidPackage } from "react-icons/bi";
import { TbPackages } from "react-icons/tb";
import { FiChevronDown, FiFile } from "react-icons/fi";
import { IoIosList } from "react-icons/io";
import { PiGear, PiSteeringWheel, PiMegaphone } from "react-icons/pi";
import { MdAddChart } from "react-icons/md";

import { CanImportTrackingShipingsUserIds } from "../../enums/CanImportTrackingShipingsUserIds";
import store from "../../store/store";
import styles from "./styles.module.scss";
import { IntegrationInstructions, Tag } from "@mui/icons-material";
import { Error } from "@material-ui/icons";
import LogoImage from "../Logos";
import { festiveLogo } from "../../enums/Logos";
import { BsPrinter } from "react-icons/bs";

const Sidebar = ({ toggleMobile, mobileBarOpen }) => {
  const { auth } = store.getState();
  const { user } = auth;
  const actualLocation = window.location.href;
  const userCanCollect = user?.canCreateCollectSchedule;
  const userIsAdmin = user?.profile === "admin";
  const canImportTrackingShippings = CanImportTrackingShipingsUserIds.includes(user.id) || userIsAdmin;
  const userHasCredtLimit = Number(user?.creditLimit) > 0;
  const [menuSelected, setMenuSelected] = useState([]);

  const handleSelectedMenu = useCallback(
    menu => {
      const find = menuSelected.find(selected => selected === menu);
      if (find) {
        const newSelecteds = menuSelected.filter(selected => selected !== menu);
        setMenuSelected([...newSelecteds]);
      } else {
        setMenuSelected([...menuSelected, menu]);
      }
    },
    [menuSelected]
  );

  return (
    <>
      <div className={`${styles.container} ${styles[mobileBarOpen ? "aberto" : "fechado"]}`}>
        <div className={styles.logo}>
          <Link to="/nova-coleta/normal-send-form">
            <LogoImage logo={festiveLogo} variant={"white"} />
          </Link>
        </div>
        <div className={styles.menuList}>
          <Link
            to="/dashboard"
            className={`${styles.menuItem} ${actualLocation.includes("/dashboard") ? styles.activeItem : ""
              }`}
          >
            <Dashboard style={{ width: "18px", height: "18px" }} />
            <p>Dashboard</p>
          </Link>

          <ul>
            <li id="new-shipping">
              <Link
                to="#"
                className={`${styles.menuItem} ${styles.menuDropdown}`}
                onClick={() => handleSelectedMenu("new-shipping")}
              >
                <div className={styles.contentLabel}>
                  <Package style={{ width: "24px", height: "24px" }} />
                  <p>Novo Envio</p>
                </div>
                <FiChevronDown style={{ width: "15px", height: "15px" }} />
              </Link>
              <div
                className={`${styles.menuHidden} ${menuSelected.includes("new-shipping") ? canImportTrackingShippings ? styles.menuShowPlus : styles.menuShow : ""
                  }`}
              >
                <div>
                  <Link
                    to="/nova-coleta/normal-send-form"
                    className={`${styles.menuItem} ${actualLocation.includes("nova-coleta/normal")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <Send style={{ width: "18px", height: "18px" }} />
                    <p>Envio normal</p>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/nova-coleta/reverse-email-form"
                    className={`${styles.menuItem} ${actualLocation.includes("nova-coleta/reverse")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <Reverse style={{ width: "18px", height: "18px" }} />
                    <p>Envio reverso</p>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/nova-coleta/import"
                    className={`${styles.menuItem} ${actualLocation.includes("nova-coleta/import")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <FaRegFileExcel />
                    <p>Importar</p>
                  </Link>
                </div>
                {canImportTrackingShippings &&
                  <div>
                    <Link
                      to="/nova-coleta/tracking-import-shipping"
                      className={`${styles.menuItem} ${actualLocation.includes("/nova-coleta/tracking-import-shipping")
                        ? styles.activeItem
                        : ""
                        }`}
                    >
                      <FaFileExcel />
                      <p>Importar para Rastreio</p>
                    </Link>
                  </div>
                }
              </div>
            </li>
          </ul>

          <ul>
            {(userIsAdmin || userCanCollect) && (
            <li id="collects-section">
              <Link
                to="#"
                className={`${styles.menuItem} ${styles.menuDropdown}`}
                onClick={() => handleSelectedMenu("collects-section")}
              >
                <div className={styles.contentLabel}>
                  <div className={styles.collectIcon}>
                    <BiSolidPackage style={{ width: "14px", height: "14px" }} />
                    <FaHandHolding style={{ width: "22px", height: "22px" }} />
                  </div>
                  <p>Coletas</p>
                </div>
                <FiChevronDown style={{ width: "15px", height: "15px" }} />
              </Link>
              <div
                className={`${styles.menuHidden} ${menuSelected.includes("collects-section") ? styles.menuShowCustom : ""
                  }`}
              >
              {userIsAdmin && (
                <div>
                  <Link
                    to="/coletas"
                    className={`${styles.menuItem} ${actualLocation.includes("/coletas") && !actualLocation.includes("/coletas/importar-coletas")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <TbPackages />
                    <p>Coletas</p>
                  </Link>
                </div>
              )}
                <div>
                  <Link
                    to="/coletas/importar-coletas"
                    className={`${styles.menuItem} ${actualLocation.includes("/coletas/importar-coletas")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <FaFileExcel />
                    <p>Importar Coleta</p>
                  </Link>
                </div>
              </div>
            </li>
            )}
          </ul>

          <Link
            to="/carrinho"
            className={`${styles.menuItem} ${actualLocation.includes("/carrinho") ? styles.activeItem : ""
              }`}
          >
            <ShoppingCart />
            <p>Meu Carrinho</p>
          </Link>
          <Link
            to="/minhas-coletas"
            className={`${styles.menuItem} ${actualLocation.includes("/minhas-coletas") ? styles.activeItem : ""
              }`}
          >
            <MyRequest />
            <p>Meus Pedidos</p>
          </Link>

          <Link
            to="/rastrear-encomenda"
            className={`${styles.menuItem} ${actualLocation.includes("/rastrear-encomenda")
              ? styles.activeItem
              : ""
              }`}
          >
            <MapPin />
            <p>Rastreamento</p>
          </Link>

          <Link
            to="/conciliacao"
            className={`${styles.menuItem} ${actualLocation.includes("/conciliacao") ? styles.activeItem : ""
              }`}
          >
            <Note />
            <p>Conciliação</p>
          </Link>
          {userIsAdmin && (
            <ul>
              <li id="own_delivery">
                <Link
                  to="#"
                  className={`${styles.menuItem} ${styles.menuDropdown}`}
                  onClick={() => handleSelectedMenu("own_delivery")}
                >
                  <div className={styles.contentLabel}>
                    <OwnDelivery />
                    <p>Entrega Própria</p>
                  </div>
                  <FiChevronDown style={{ width: "15px", height: "15px" }} />
                </Link>
                <div
                  className={`${styles.menuHidden} ${menuSelected.includes("own_delivery") ? styles.menuShowPlus2 : ""}`}
                >
                  <div>
                    <div>
                      <Link
                        to="/rastrear-motorista"
                        className={`${styles.menuItem} ${actualLocation.includes("/rastrear-motorista")
                          ? styles.activeItem
                          : ""
                          }`}
                      >
                        <Map />
                        <p>Motorista</p>
                      </Link>
                    </div>
                    <div>
                      <Link
                        to="/listagem-rotas"
                        className={`${styles.menuItem} ${actualLocation.includes("/listagem-rotas")
                          ? styles.activeItem
                          : ""
                          }`}
                      >
                        <OwnDelivery />
                        <p>Rotas</p>
                      </Link>
                    </div>
                    <div>
                      <Link
                        to="/adicionar-rota"
                        className={`${styles.menuItem} ${actualLocation.includes("/adicionar-rota")
                          ? styles.activeItem
                          : ""
                          }`}
                      >
                        <Marker />
                        <p>Criar rota</p>
                      </Link>
                    </div>

                    <div>
                      <Link
                        to="/sugestao-rotas"
                        className={`${styles.menuItem} ${actualLocation.includes("/sugestao-rotas") ? styles.activeItem : ""
                          }`}
                      >
                        <CalendarTime style={{ width: "18px", height: "18px" }} />
                        <p>Sugestão de Rotas</p>
                      </Link>
                    </div>
                    <div>
                      <Link
                        to="/contador-super-expresso"
                        className={`${styles.menuItem} ${actualLocation.includes("/contador-super-expresso") ? styles.activeItem : ""
                          }`}
                      >
                        <MdAddChart />
                        <p>Quantidade</p>
                      </Link>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          )}

          {(userIsAdmin || (!userCanCollect && userHasCredtLimit)) && (
            <Link
              to="/faturamento"
              className={`${styles.menuItem} ${actualLocation.includes("/faturamento") ? styles.activeItem : ""
                }`}
            >
              <PigMoney style={{ width: "24px", height: "24px" }} />
              <p>Faturamento</p>
            </Link>
          )}

          {userIsAdmin && (
            <Link
              to="/politica-de-preco"
              className={`${styles.menuItem} ${actualLocation.includes("/politica-de-preco")
                ? styles.activeItem
                : ""
                }`}
            >
              <DollarSign />
              <p>Política de Preço</p>
            </Link>
          )}

          <ul>
            <li id="integration">
              <Link
                to="#"
                className={`${styles.menuItem} ${styles.menuDropdown}`}
                onClick={() => handleSelectedMenu("integration")}
              >
                <div className={styles.contentLabel}>
                  <Integration />
                  <p>Integrações</p>
                </div>
                <FiChevronDown style={{ width: "15px", height: "15px" }} />
              </Link>
              <div
                className={`${styles.menuHidden} ${menuSelected.includes("integration") ? styles.menuShow : ""
                  }`}
                style={userIsAdmin ? { maxHeight: "160px" } : { maxHeight: "70px" }}
              >
                <div>
                  <Link
                    to="/integracoes"
                    className={`${styles.menuItem} ${actualLocation.includes("integracoes")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <PiGear />
                    <p>Configuração</p>
                  </Link>
                </div>
                {userIsAdmin && (
                  <div>
                    <Link
                      to="/tabelas-frete"
                      className={`${styles.menuItem} ${actualLocation.includes("tabelas-frete")
                        ? styles.activeItem
                        : ""
                        }`}
                    >
                      <IntegrationTable />
                      <p>Tabelas</p>
                    </Link>
                  </div>
                )}
                {userIsAdmin && (
                  <div>
                    <Link
                      to="/integracao/relatorios"
                      className={`${styles.menuItem} ${actualLocation.includes("relatorios-integracoes")
                        ? styles.activeItem
                        : ""
                        }`}
                    >
                      <FiFile />
                      <p>Relatórios</p>
                    </Link>
                  </div>
                )}
              </div>
            </li>
          </ul>


          {userIsAdmin && (
            <ul>
              <li id="management">
                <Link
                  to="#"
                  className={`${styles.menuItem} ${styles.menuDropdown}`}
                  onClick={() => handleSelectedMenu("management")}
                >
                  <div className={styles.contentLabel}>
                    <Management />
                    <p>Gestão</p>
                  </div>
                  <FiChevronDown style={{ width: "15px", height: "15px" }} />
                </Link>
                <div
                  className={`${styles.menuHidden} ${menuSelected.includes("management") ? styles.menuShow : ""
                    }`}
                >
                  <Link
                    to="/users"
                    className={`${styles.menuItem} ${actualLocation.includes("/users") ? styles.activeItem : ""
                      }`}
                  >
                    <User />
                    <p>Usuários</p>
                  </Link>
                  <Link
                    to="/anuncios"
                    className={`${styles.menuItem} ${actualLocation.includes("/anuncios") ? styles.activeItem : ""
                      }`}
                  >
                    <PiMegaphone size={18} />
                    <p>Anúncios</p>
                  </Link>
                  <Link
                    to="/imprimir-etiquetas"
                    className={`${styles.menuItem} ${actualLocation.includes("/imprimir-etiquetas") ? styles.activeItem : ""
                      }`}
                  >
                    <BsPrinter />
                    <p>Imprimir Etiquetas</p>
                  </Link>
                  <Link
                    to="/validar-correios"
                    className={`${styles.menuItem} ${actualLocation.includes("/validar-correios") ? styles.activeItem : ""
                      }`}
                  >
                    <DollarSign />
                    <p>Validar Correios</p>
                  </Link>
                  <Link
                    to="/gerenciar-integracoes"
                    className={`${styles.menuItem} ${actualLocation.includes("gerenciar-integracoes")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <IntegrationInstructions />
                    <p>Gerenciar Integrações</p>
                  </Link>
                  <Link
                    to="/motoristas"
                    className={`${styles.menuItem} ${actualLocation.includes("/motoristas") ? styles.activeItem : ""
                      }`}
                  >
                    <PiSteeringWheel />
                    <p>Motoristas</p>
                  </Link>
                  <Link
                    to="/gerenciar-erros"
                    className={`${styles.menuItem} ${actualLocation.includes("gerenciar-erros")
                      ? styles.activeItem
                      : ""
                      }`}
                  >
                    <Error />
                    <p>Erros</p>
                  </Link>
                  <Link
                    to="/relatorio/super-expressa"
                    className={`${styles.menuItem} ${actualLocation.includes("/relatorio/super-expressa") ? styles.activeItem : ""
                      }`}
                  >
                    <MyRequest />
                    <p>Relatórios</p>
                  </Link>

                  <Link
                    to="/gestao-ceps"
                    className={`${styles.menuItem} ${actualLocation.includes("/gestao-ceps") ? styles.activeItem : ""
                      }`}
                  >
                    <IoIosList />
                    <p>Gestão de CEPs</p>
                  </Link>
                  <Link
                    to="/validacao-esteira"
                    className={`${styles.menuItem} ${actualLocation.includes("/validacao-esteira") ? styles.activeItem : ""
                      }`}
                  >
                    <SlideSearch />
                    <p>Validação Esteira</p>
                  </Link>
                  <Link
                    to="/gestao-feriados"
                    className={`${styles.menuItem} ${actualLocation.includes("/gestao-feriados") ? styles.activeItem : ""
                      }`}
                  >
                    <CalendarTime style={{ width: "24px", height: "24px" }} />
                    <p>Feriados</p>
                  </Link>
                </div>
              </li>
            </ul>
          )}
        </div>
      </div>
      {mobileBarOpen && <div className={styles.tapToClose} onClick={() => toggleMobile(!mobileBarOpen)} />}
    </>
  );
};

export { Sidebar };

